"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _css = _interopRequireDefault(require("@styled-system/css"));

var _styledSystem = require("styled-system");

var _system = _interopRequireWildcard(require("../../utils/system"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizesValues = {
  lg: 'lg',
  md: 'md',
  sm: 'sm'
};
var statusValues = {
  danger: 'danger',
  info: 'info',
  success: 'success',
  warning: 'warning'
};
var propsTypes = {
  /**
   * The content of the modal.
   */
  children: _propTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the components.
   */
  classes: (0, _propTypes.shape)({
    bullet: (0, _propTypes.oneOfType)([(0, _propTypes.shape)({}), _propTypes.func])
  }),

  /**
   * Control the size of the bullet.
   */
  size: (0, _propTypes.oneOf)(Object.values(sizesValues)),

  /**
   * Control the color of the bullet.
   */
  status: (0, _propTypes.oneOf)(Object.values(statusValues))
};
var defaultProps = {
  classes: {
    bullet: null
  },
  size: sizesValues.md,
  status: statusValues.info
};
var StatusIndicator = (0, _system["default"])('div')({
  label: 'StatusIndicator'
}, (0, _css["default"])({
  alignItems: 'center',
  display: 'flex'
}));
var StatusIndicatorBullet = (0, _base["default"])("span", process.env.NODE_ENV === "production" ? {
  target: "ean5t8z0"
} : {
  target: "ean5t8z0",
  label: "StatusIndicatorBullet"
})((0, _css["default"])({
  borderRadius: '50%',
  display: 'inline-block',
  mr: 2
}), (0, _styledSystem.variant)({
  scale: 'statusIndicator',
  prop: 'status',
  variants: {
    danger: {
      bg: 'danger'
    },
    info: {
      bg: 'info'
    },
    warning: {
      bg: 'warning'
    },
    success: {
      bg: 'success'
    }
  }
}), (0, _styledSystem.variant)({
  scale: 'statusIndicator',
  prop: 'size',
  variants: {
    sm: {
      size: 2
    },
    md: {
      size: 3
    },
    lg: {
      size: 4
    }
  }
}), (0, _system.classesStyles)('bullet'));

var Component = function Component(_ref) {
  var size = _ref.size,
      status = _ref.status,
      children = _ref.children,
      classes = _ref.classes,
      props = _objectWithoutProperties(_ref, ["size", "status", "children", "classes"]);

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StatusIndicator, _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StatusIndicatorBullet, {
      classes: classes,
      size: size,
      status: status
    }), children]
  }));
};

Component.displayName = 'StatusIndicator';
Component.propTypes = propsTypes;
Component.defaultProps = defaultProps;
var _default = Component;
exports["default"] = _default;

//# sourceMappingURL=StatusIndicator.js.map